import type { StudentCohortAssignmentReleased } from "../auth/api-client";
import type { AssignmentProgressStatus } from "./assignmentProgressStatus";

export type StudentOpenStatus = "not_started" | "in_progress" | "complete";
export type StudentClosedStatus = "missed" | "incomplete" | "complete";
export type StudentDisplayStatus = StudentOpenStatus | StudentClosedStatus;

export const STUDENT_OPEN_LABELS: Record<StudentOpenStatus, string> = {
  not_started: "Not Started",
  in_progress: "In Progress",
  complete: "Complete",
};

export const STUDENT_CLOSED_LABELS: Record<StudentClosedStatus, string> = {
  missed: "Missed",
  incomplete: "Incomplete",
  complete: "Complete",
};

function resolveProgress(a: StudentCohortAssignmentReleased): AssignmentProgressStatus {
  if (a.progressStatus) return a.progressStatus;
  if (a.credited || a.everRequiredPassed) return "complete";
  if ((a.submissionAttemptCount ?? 0) > 0) return "needs_help";
  return "not_started";
}

export function deriveStudentDisplayStatus(a: StudentCohortAssignmentReleased): StudentDisplayStatus {
  const progress = resolveProgress(a);
  if (a.closed) {
    if (progress === "complete") return "complete";
    if (progress === "not_started") return "missed";
    return "incomplete";
  }
  if (progress === "complete") return "complete";
  if (progress === "not_started") return "not_started";
  return "in_progress";
}

export function studentDisplayStatusLabel(a: StudentCohortAssignmentReleased): string {
  const status = deriveStudentDisplayStatus(a);
  if (a.closed) return STUDENT_CLOSED_LABELS[status as StudentClosedStatus];
  return STUDENT_OPEN_LABELS[status as StudentOpenStatus];
}

export function studentAssignmentOpen(a: StudentCohortAssignmentReleased): boolean {
  return Boolean(a.open);
}
